import { render, staticRenderFns } from "./lawsuit-kind.vue?vue&type=template&id=30f2101b&scoped=true"
import script from "./lawsuit-kind.vue?vue&type=script&lang=ts"
export * from "./lawsuit-kind.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f2101b",
  null
  
)

export default component.exports